import { createContext } from 'react';
import { defaultPlaybooksProps } from './constants';
export const PlaybooksPropsContext = /*#__PURE__*/createContext(defaultPlaybooksProps);